import { styled } from "styled-components";

export const PaymentContainer = styled.div`
  margin: 24px;
  padding: 16px;
  border: 1px solid #ccc;
`;
